<template>
    <div class="login-wrap">
      <el-form :rules="rules" ref="formInline" :model="formInline"  class="login-container">
        <h1 class="title">商户登陆</h1>
        <el-form-item prop="loginName">
          <el-input type="text" v-model="formInline.loginName"  placeholder="用户账号" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="loginPassword">
          <el-input type="password" v-model="formInline.loginPassword" placeholder="用户密码" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="doLogin('formInline')" style="width: 100%;">登陆</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="register()" style="width: 100%;">注册</el-button>
        </el-form-item>
      </el-form>
      <el-dialog title="选择权限" width="400px" :visible.sync="dialogFormVisible">
        <el-tree
            :data="treeListData"
            show-checkbox
            default-expand-all
            node-key="guid"
            ref="tree"
            highlight-current
            :props="defaultProps">
        </el-tree>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="onProcessQueDing()">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import Base64 from '../utils/base64'
import authorityApi from '../api/authority/authority'
import store from '../store'
// garyguoshop   qghwei1217
export default {
  name: 'login',
  data () {
    return {
        dialogFormVisible: false,
        formInline:{
            loginName: '',
            loginPassword: '',
        },
        treeListData: [],
        selectTreeListData: [],
        defaultProps: {
          children: 'children',
          label: 'permissionName'
        },
        rules: {
            loginName: [
                { required: true, message: '请输入用户名称', trigger: 'blur' }
            ],
            loginPassword: [
                { required: true, message: '请输入密码', trigger: 'blur' }
            ]
        },
    }
  },
  created(){
  },

  methods: {

    onProcessQueDing(){
      this.addBusUserPermMapList();
            // console.log(this.$refs.tree.getCheckedKeys())
    },

    doLogin(formName){
        let _this = this;
        this.$refs[formName].validate((valid) => {
            if (valid) {
                // 登录接口
                // _this.checkLoginName();
                let login = {
                  loginPassword: Base64.encode64(Base64.strUnicode2Ansi(_this.formInline.loginPassword)),
                  loginName: Base64.encode64(Base64.strUnicode2Ansi(_this.formInline.loginName))
                }
                this.$store.dispatch('user/login', login).then((res) => {
                  // console.log(res)
                  if(res.permissionType == 0 && res.customerType == 6){
                    this.queryListAll();
                  }else if(res.permissionType == 0 && res.customerType != 6){
                    this.$message.error('错误提示：您还没有权限！');
                    store.dispatch('user/LogOut').then(() => {
                    // Message.error(err || '获取用户信息失败，请重试')
                      // next({ path: '/login' })
                    });
                  }else{
                      _this.$router.push({path: '/'}).catch(() =>{});
                  }
                  // console.log(res)

                });

            }else{
                return false;
            }
        })
    },
    // 查询所以菜单
    queryListAll(){
      authorityApi.querySystemPermssionByRoleType6().then(res =>{
        // console.log(res)
            if(res.code == 0){
                // console.log(res)
                this.treeListData = res.data;
                this.dialogFormVisible = true;
                this.selectTreeListData = [];
                this.forEachList(res.data);
                this.setCheckedNodes(this.selectTreeListData);

            }else{
              this.$message.error('错误提示：'+res.msg);
                // Message({message: '错误提示：'+res.msg,type: 'error'});
            }
        })
    },
    forEachList(res){
        res.forEach(item => {
            item.label = item.permissionName;
            if(item.children == null || item.children.length == 0 && item.checkPermssion == 1){
                this.selectTreeListData.push({
                    label: item.permissionName,
                    guid: item.guid
                });
            }
            if(item.children != null){
                this.forEachList(item.children);
            }
        });
    },
    setCheckedNodes(res) {
        setTimeout(() =>{
          this.$refs.tree.setCheckedNodes(res);
        },100)

    },
    // 批量添加权限
    addBusUserPermMapList(){
      authorityApi.addBusUserPermMapList({
        permissionGuids: this.$refs.tree.getCheckedKeys()
      }).then(res =>{
            // console.log(res)
            if(res.code == 0){
              this.$message.success('添加成功');
                // resolve(nodes);
                this.$router.push({path: '/'}).catch(() =>{});
            }else{
              this.$message.error('错误提示：'+res.msg);

            }
        });
    },
    register(){
        this.$router.push({path: '/register'}).catch((res) =>{});
    }
  }

}
</script>

<style scoped>
    .login-wrap {
      background-image: url('../assets/busWineDeviceBag.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
  		box-sizing: border-box;
  		width: 100%;
  		height: 100vh;
  		padding-top: 10%;
  		/* background-color: #112346; */
  		background-repeat: no-repeat;
  		background-position: center right;
  		background-size: 100%;
  	}

  	.login-container {
  		border-radius: 10px;
  		margin: 0px auto;
  		width: 350px;
  		padding: 30px 35px 15px 35px;
  		background: #fff;
  		border: 1px solid #eaeaea;
  		text-align: left;
  		box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
  	}

  	.title {
  		margin: 0px auto 40px auto;
  		text-align: center;
  		color: #505458;
  	}
</style>



// WEBPACK FOOTER //
// src/views/login.vue